<template>
  <b-row>
    <b-col lg="10" md="10" cols="10">
      <!--le quite responsive al componente -->
      <VueSlickCarousel
        v-if="content"
        id="carrusel-slider-id"
        class="carrusel-slider w-50 h-50"
        ref="carousel"
        v-bind="settings"
      >
        <div
          class="carrusel-associate-icon text-center center-block"
          v-for="(i, index) in content"
          :key="index"
        >
          <img v-bind:src="i.img_path_thumb" alt="" />
        </div>
      </VueSlickCarousel>
    </b-col>
    <b-col lg="2" md="10" cols="2" class="carrusel-content-next">
      <img
        class="cursor-pointer"
        src="@/assets/images/Shape.png"
        @click="showNext"
        alt="Next icon img"
      />
    </b-col>
  </b-row>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  name: "section-associate",
  components: { VueSlickCarousel },
  props: {
    settings: Object,
    content: Array,
  },
  data: () => ({}),
  methods: {
    showNext() {
      this.$refs.carousel.next();
    },
    showPrev() {
      this.$refs.carousel.prev();
    },
  },
};
</script>
<style scoped>
.carrusel-associate-icon img {
  max-height: 120px;
  width: auto;
  margin: 0 auto;
  display: block;
}
.h-50 {
  height: 150px !important;
}
.w-50 {
  width: 150px !important;
}
</style>
